<template>
  <div class="page__bd bm" id="list">
    <toobarhead :showRefresh="false" :showBack="true" :showMore="false" :titleName="'详情'"></toobarhead>
    <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label">自动编号&nbsp;&nbsp;</label></div>
        <div class="weui-cell__bd"> {{ contract.no }} </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd"><label class="weui-label">文件标题&nbsp;&nbsp;</label></div>
        <div class="weui-cell__bd">
          {{ contract.title }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">当前流程&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ showProcess }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">审批状态&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ showAuditState }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">申请人&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.owner }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">所属部门&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.departmentName }}
        </div>
      </div>
      <div class="weui-cell" v-show="showAction">
        <div class="weui-cell__hd">
          <label class="weui-label">合同类别&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.actionLabel }}
        </div>
      </div>
      <div class="weui-cell" v-show="showType">
        <div class="weui-cell__hd">
          <label class="weui-label">合同性质&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.typeLabel }}
        </div>
      </div>
      <div class="weui-cell" v-show="showAmount">
        <div class="weui-cell__hd">
          <label class="weui-label">标的金额&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.amountLevelLabel }}
        </div>
      </div>
      <div class="weui-cell" v-show="showDirector">
        <div class="weui-cell__hd">
          <label class="weui-label">谈判负责人&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.director }}
        </div>
      </div>
      <div class="weui-cell" v-show="showPhone">
        <div class="weui-cell__hd">
          <label class="weui-label">负责人电话&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.directorTel }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">我方公司&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.companyName }}
        </div>
      </div>
      <div class="weui-cell" v-show="otherCompany">
        <div class="weui-cell__hd">
          <label class="weui-label">相对方公司&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ contract.otherName }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">所需印章&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ seal }}
        </div>
      </div>
      <div class="weui-cell" v-show="this.contract.type=='4'">
        <div class="weui-cell__hd">
          <label class="weui-label">盖章文件类型&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ showSealType }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">风险等级&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ showRiskLevel }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">不得修改合同&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ showIsNotModify }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">创建时间&nbsp;&nbsp;</label>
        </div>
        <div class="weui-cell__bd">
          {{ createtime }}
        </div>
      </div>
          <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">备注&nbsp;&nbsp;</label>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <textarea class="weui-textarea" placeholder="无备注内容" rows="2" readonly="" v-model="contract.comment"></textarea>
        </div>
      </div>
    </div>
    <div class="weui-cells__title attach">合同附件</div>
    <div class="weui-cells">
      <a v-for="attach in contract.attachList" class="weui-cell weui-cell_access" @click.prevent.stop="checkFile(attach)">
        <div class="weui-cell__bd">
            <p>{{attach.fileName}}</p>
        </div>
        <div class="weui-cell__ft"></div>
      </a>
    </div>
    <div class="fd">
      <div class="fd_l fl" @click.prevent='detail(contract.id)'>
        <a class="btn_batch_repay" @click.prevent>审批详情</a>
      </div>
      <div class="fd_r fr" v-show="showRevoke" @click.prevent='confirmRevoke()'>
        <a class="btn_batch_repay" @click.prevent>审核撤回</a>
      </div>
      <div class="fd_r fr" v-show='showAuditBtn' @click.prevent='audit(contract.id)'>
        <a class="btn_batch_repay" @click.prevent>审核</a>
      </div>
      <div class="fd_r fr" v-show='showSealBtn' @click.prevent='showSealConfirm()'>
        <a class="btn_batch_repay" @click.prevent>确认盖章</a>
      </div>
      <div class="fd_r fr" v-show='showFileBtn' @click.prevent='showFileConfirm()'>
        <a class="btn_batch_repay" @click.prevent>合同归档</a>
      </div>
    </div>
    <div id="contract-full-popupe" class='weui-popup-container'>
      <div class="weui-popup-overlay"></div>
      <div class="weui-popup-modal">
        <header class='demos-header'>
          <!-- <h2 class="demos-second-title">附件查看</h2> -->
          <p class="demos-sub-title"><div class="close-popup-btn"><button class="weui-btn weui-btn_plain-default close-popup">关闭</button></div></p>
        </header>
        <article class="weui_article" style="position: fixed; width: 100%; height:80%; -webkit-overflow-scrolling: touch; overflow-y: scroll;">
        <iframe :src="path" width="97%" height="100%" frameborder="no" scrolling="true"></iframe>
        </article>
      </div>
    </div>
    <div class="dialogs">
      <div class="js_dialog" id="revokeConfirm" style="display: none;">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">确认撤回</strong></div>
          <div class="weui-dialog__bd">确定进行撤回的操作吗</div>
          <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancelRevoke">放弃</a>
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="revoke()">确定</a>
          </div>
        </div>
      </div>

      <div class="js_dialog" id="sealConfirm" style="display: none;">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">确认盖章</strong></div>
          <div class="weui-dialog__bd">确定进行盖章的操作吗</div>
          <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancelSeal">放弃</a>
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="submitSeal('seal', '合同盖章')">确定</a>
          </div>
        </div>
      </div>
      <div class="js_dialog" id="fileConfirm" style="display: none;">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
          <div class="weui-dialog__hd"><strong class="weui-dialog__title">确认归档</strong></div>
          <div class="weui-dialog__bd">确定进行归档的操作吗</div>
          <div class="weui-dialog__ft">
            <a class="weui-dialog__btn weui-dialog__btn_default" @click.prevent="cancelFile">放弃</a>
            <a class="weui-dialog__btn weui-dialog__btn_primary" @click.prevent="submitFile('file','合同归档')">确定</a>
          </div>
        </div>
      </div>
      <div class="js_dialog" v-show="showtip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">提示</strong></div>
        <div class="weui-dialog__bd">{{tipContent}}</div>
        <div class="weui-dialog__ft">
            <a @click.prevent.stop='goBack' class="weui-dialog__btn weui-dialog__btn_primary">知道了</a>
        </div>
      </div>
    </div>
    <div class="js_dialog showNoAttachTip" v-show="showNoAttachTip">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd"><strong class="weui-dialog__title">操作被终止</strong></div>
        <div class="weui-dialog__bd">当前没有生成可查看附件，请在电脑端登录系统查看</div>
        <div class="weui-dialog__ft">
            <a @click.prevent.stop='gotit' class="weui-dialog__btn weui-dialog__btn_primary">知道了</a>
        </div>
      </div>
    </div>
    </div>
    <transition name="slide-fade">
      <div v-if='showOperateSuccessToast'>
        <div class="weui-toast">
          <i class="weui-icon-success-no-circle weui-icon_toast"></i>
          <p class="weui-toast__content">已完成</p>
        </div>
      </div>
    </transition>
    <div v-if='showProcessToast'>
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">操作中...</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import toobarhead from './head'
  export default {
    computed: {
      ...mapGetters([
        'currentContract'
      ]),
      currentOp () {
        return this.$route.params.op
      },
      backOp () {
        return this.$route.params.op
      },
      isRead () {
        return this.contract.isRead
      },
      hasAuditRevoke () {
        return this.contract.hasAuditRevoke
      },
      state () {
        return this.contract.state
      },
      backTitle () {
        let op = this.backOp
        if (op === 'seal') {
          return '合同盖章'
        } else if (op === 'file') {
          return '合同归档'
        } else if (op === 'audit') {
          return '合同信息'
        }
        return ''
      },
      showSealBtn () {
        return this.currentOp === 'seal'
      },
      showFileBtn () {
        return this.currentOp === 'file'
      },
      showAuditBtn () {
        return this.currentOp === 'audit'
      },
      showRevoke () {
        return this.currentOp === 'history' && !this.isRead && this.state !== 10 && this.hasAuditRevoke
      },
      showProcess () {
        if (this.contract['processType'] === 1) return '合同流程'
        if (this.contract['processType'] === 2) return '盖章文件流程'
        if (this.contract['processType'] === 3) return '废除合同流程'
        if (this.contract['processType'] === 4) return '重新归档流程'
      },
      showAuditState () {
        if (this.contract['taskName'] === 'legal' && this.contract['processType'] === 1) return '法务审核'
        if (this.contract['taskName'] === 'file' && this.contract['processType'] === 1) return '待归档'
        if (this.contract['taskName'] === 'file' && this.contract['processType'] === 3) return '归档确认废除'
        if (this.contract['taskName'] === 'legal' && this.contract['processType'] === 3) return '法务审核废除'
        if (this.contract['taskName'] === 'apply') return '待提交申请'
        if (this.contract['taskName'] === 'finish') return '审批完成'
        if (this.contract['taskName'] === 'departmentSeal') return '印章保管部门审核'
        if (this.contract['taskName'] === 'chairman') return '董事长'
        if (this.contract['taskName'] === 'department') return '部门审核'
        if (this.contract['taskName'] === 'finance') return '财务审核'
        if (this.contract['taskName'] === 'seal') return '印章保管人'
        if (this.contract['taskName'] === 'ceo') return '总经理审核'
        if (this.contract['taskName'] === 'consult') return '法务咨询'
        if (this.contract['taskName'] === 'headquarters') return '总部审核'
      },
      seal () { // 转换印章显示
        if (!this.contract['sealList']) return ''
        return this.contract.sealList.map(selSel => selSel['name']).toString()
      },
      createtime () { // 转换创建时间
        if (!this.contract['createTime']) return ''
        return new Date(this.contract.createTime).toLocaleString()
      },
      showAction () { // 是否显示合同类别
        return this.contract['type'] && (this.contract.type !== 4 && this.contract.type !== 5)
      },
      showSealType () {
        if (this.contract['stype'] === 0) return '一般盖章文件'
        if (this.contract['stype'] === 1) return '重要盖章文件'
        if (this.contract['stype'] === 2) return '报价单'
      },
      showIsNotModify () {
        if (this.contract['isNotModify']) return '是'
        if (!this.contract['isNotModify']) return '否'
      },
      showRiskLevel () {
        if (this.contract['riskLevel'] === 0) return '不评估风险'
        if (this.contract['riskLevel'] === 1) return '一般、较大风险'
        if (this.contract['riskLevel'] === 2) return '重大风险'
      },
      showType () {
        return true
      },
      showAmount () {
        if (this.contract['action'] && this.contract['action'] === 2) return false
        return this.contract['type'] && (this.contract.type !== 4 && this.contract.type !== 5)
      },
      showPhone () {
        return this.contract['type'] && this.contract.type !== 4
      },
      otherCompany () {
        return this.contract['type'] && this.contract.type !== 4
      },
      showDirector () {
        return this.contract['type'] && this.contract.type !== 4
      },
      showNoAttachTip () {
        return false
      }
    },
    data () {
      return {
        contract: {
          attachList: []
        },
        content: '',
        path: '',
        image: [],
        showOperateSuccessToast: false,
        showProcessToast: false,
        showtip: false,
        tipContent: '',
        pb2: null // 图片浏览器
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        let vm = this
        let route = this.$route
        if (vm.currentContract === null) {
          var data = {
            op: vm.currentOp
          }
          if (route.query.orderId) {
            data['orderId'] = route.query.orderId
          }
          if (route.query.taskId) {
            data['taskId'] = route.query.taskId
          }
          if (route.query.taskName) {
            data['taskName'] = route.query.taskName
          }
          vm.findContract({
            id: route.params.contractId,
            data: data
          }).then(c => { // 获取到当前合同信息后进行处理
            vm.contract = c
          }).catch(errMsg => {
            vm.tipContent = errMsg
            vm.showtip = true
          })
        } else {
          vm.contract = vm.currentContract
        }
      })
    },
    watch: {
      contract: function (val) {
      }
    },
    components: {
      toobarhead
    },
    beforeDestroy () {
      if (this.pb2) {
        this.pb2.close()
      }
    },
    methods: {
      ...mapActions([
        'findContract'
      ]),
      gotit: function () {
        this.showNoAttachTip = false
      },
      goBack: function () {
        let vm = this
        setTimeout(function () {
          vm.$router.push({path: '/list/' + vm.backOp, query: {showNavbar: vm.$route.query.showNavbar, showBack: false, tname: vm.backTitle, refresh: true, selected: vm.$route.query.selected}})
        }, 200)
      },
      audit: function (contractId) {
        this.$router.push({path: '/verifie/' + this.contract.id, query: {orderId: this.contract.orderId, taskId: this.contract.taskId, taskName: this.contract.taskName}})
      },
      detail: function (contractId) {
        this.$router.push({path: '/log/' + this.contract.id, query: {risk: this.contract.risk}})
      },
      confirmRevoke () {
        window.$('#revokeConfirm').fadeIn(100)
      },
      revoke () {
        let revokeType
        let vm = this
        // let route = vm.$route
        if (this.contract.taskName === 'apply') {
          // 申请撤回
          revokeType = 18
        } else {
          // 审核撤回
          revokeType = 15
        }
        this.$http.post('rest/api/revoke/' + this.contract.id, {taskId: this.contract.taskId, revokeType: revokeType, processType: this.contract.processType}).then(function (response) {
          vm.showProcessToast = false
          if (response.data.ok) {
            vm.showOperateSuccessToast = true
            setTimeout(function () {
              vm.showOperateSuccessToast = false
              setTimeout(function () {
                vm.goBack()
              }, 200)
            }, 700)
          } else {
            vm.tipContent = response.data.msg
            vm.showtip = true
          }
        }, function (response) {
          window.$('#sealConfirm').fadeOut(200)
          vm.showProcessToast = false
        })
      },
      checkFile: function (attach) {
        this.image = []
        let imgPath = attach.uploadUrl
        let path = imgPath + attach.path.replace(attach.uploadPath + '/', '')
        if (attach.type === 2 || attach.type === 4) {  // img
          this.image.push({image: path, caption: attach.title, attachid: attach.id})
          this.pb2 = window.$.photoBrowser({items: this.image, initIndex: 0})
          this.pb2.open()
        } else {  // doc、pdf、xls...
          window.open(path)
        }
        if (attach.path === '') {
          this.showNoAttachTip = true
        }
      },
      submitSeal: function (op, title) {
        let vm = this
        vm.backOp = op
        vm.backTitle = title
        window.$('#sealConfirm').fadeOut(100)
        vm.showProcessToast = true
        let route = vm.$route
        vm.$http.post('rest/api/seal/' + route.params.contractId, {orderId: route.query.orderId, taskId: route.query.taskId, taskName: route.query.taskName}).then(function (response) {
          vm.showProcessToast = false
          if (response.data.ok) {
            vm.showOperateSuccessToast = true
            setTimeout(function () {
              vm.showOperateSuccessToast = false
              setTimeout(function () {
                vm.$router.push({path: '/list/seal', query: {showNavbar: route.query.showNavbar, showBack: false, tname: '合同盖章', refresh: true, selected: route.query.selected}})
              }, 200)
            }, 700)
          } else {
            vm.tipContent = response.data.msg
            vm.showtip = true
          }
        }, function (response) {
          window.$('#sealConfirm').fadeOut(200)
          vm.showProcessToast = false
        })
      },
      submitFile: function (op, title) {
        let vm = this
        vm.backOp = op
        vm.backTitle = title
        vm.showProcessToast = true
        window.$('#fileConfirm').fadeOut(100)
        let route = vm.$route
        vm.$http.post('rest/api/file/' + route.params.contractId, {orderId: route.query.orderId, taskId: route.query.taskId, taskName: route.query.taskName}).then(function (response) {
          vm.showProcessToast = false
          if (response.data.ok) {
            vm.showOperateSuccessToast = true
            setTimeout(function () {
              vm.showOperateSuccessToast = false
              setTimeout(function () {
                vm.$router.push({path: '/list/file', query: {showNavbar: route.query.showNavbar, showBack: false, tname: '合同归档', refresh: true, selected: route.query.selected}})
              }, 200)
            }, 700)
          } else {
            vm.tipContent = response.data.msg
            vm.showtip = true
          }
        }, function (response) {
          window.$('#fileConfirm').fadeOut(200)
          vm.showProcessToast = false
        })
      },
      showSealConfirm: function () {
        if (this.showProcessToast) { return }
        window.$('#sealConfirm').fadeIn(200)
      },
      showFileConfirm: function () {
        if (this.showProcessToast) { return }
        window.$('#fileConfirm').fadeIn(200)
      },
      cancelSeal: function () {
        window.$('#sealConfirm').fadeOut(200)
      },
      cancelRevoke: function () {
        window.$('#revokeConfirm').fadeOut(200)
      },
      cancelFile: function () {
        window.$('#fileConfirm').fadeOut(200)
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {})
    },
    beforeRouteLeave (to, from, next) { // 导航离开该组件的对应路由时调用
      var vm = this
      if (vm.pb2) {
        vm.pb2.close()
        vm.pb2 = null
        next(false)
        return
      }
      next(true)
    }
  }
</script>
<style>
  .fd {
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #eee;
    background-color: #fff;
    z-index: 1;
  }
  .fd_r {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #eaeaea;
    float: right;
  }
  .fd_l {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #eaeaea;
    float: left;
  }
  .bm {
    margin-bottom: 40px
  }
  .weui-cells__title {
    color: #999999
  }
  .attach{
    font-size: 18px;
    font-weight: bold
  }
  iframe{
    margin: 5px auto;
  }
  .close-popup-btn{
    width: 50%;
    margin: 2px auto
  }
</style>



// WEBPACK FOOTER //
// contract.vue?32115e1b